import { createContext } from 'react';

export const DynamicFieldNameRootContext = createContext<string>('');
DynamicFieldNameRootContext.displayName = 'DynamicFieldNameRootContext';
